export const logoNegative = ['608 134', `
  <title>nmdc edge</title>
  <g>
    
  </g>
`]
